import { render } from "./ui-minutes.vue?vue&type=template&id=96bedb0a&ts=true"
import script from "./ui-minutes.vue?vue&type=script&lang=ts"
export * from "./ui-minutes.vue?vue&type=script&lang=ts"

import "./ui-minutes.vue?vue&type=style&index=0&id=96bedb0a&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__